export default {
  props: {
    availableLocales: {
      type: Array,
      required: false,
      default: () => [
        { name: 'Português - Brasil', code: 'pt-br', current: true },
        { name: 'English', code: 'en' },
        { name: 'Español', code: 'es' },
      ],
    },
    exclusiveUrlLocales: Array,
    localeTitle: {
      type: String,
      required: false,
      default: '',
    },
    changeRoute: Function,
  },

  data() {
    return {
      isOpen: false,
      localeName: '&nbsp;',
      currentLocale: this.availableLocales.find((locale) => locale.current),
      locales: this.getLocales(),
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.localeItems = this.$refs?.dropdownRef

      window.addEventListener('keyup', this.keyup)
      window.addEventListener('resize', this.resize)
      window.dispatchEvent(new Event('resize'))
    })
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.keyup)
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    open() {
      this.isOpen = true
    },

    close() {
      this.isOpen = false
    },

    keyup(e) {
      if (e.keyCode === 27 && this.isOpen) this.close()
    },

    select($event) {
      const localeCode = $event?.currentTarget?.getAttribute('name')

      this.close()

      this.changeLocale(localeCode)

      this.changeRoute && this.changeRoute(localeCode)
    },

    changeLocale(localeCode) {
      this.currentLocale = this.availableLocales.find(
        (locale) => locale.code === localeCode
      )
    },

    getIconClass() {
      return this.isOpen ? '-opened' : '-closed'
    },

    getLocales() {
      if (!this.exclusiveUrlLocales?.length) {
        return this.availableLocales
      }

      const pathname = process.browser
        ? window.location.pathname
        : this.$route.path

      const exclusiveUrlLocale = this.exclusiveUrlLocales.find(
        (locale) => locale.pathname === pathname
      )

      if (!exclusiveUrlLocale) {
        return this.availableLocales
      }

      return this.availableLocales.filter(
        (availableLocale) => availableLocale.code === exclusiveUrlLocale.code
      )
    },
  },
}
